`<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('bulletin.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'bulletins' }">{{ $t('bulletin.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'course-cancel-bulletin' }">{{ $t('course-cancel-bulletin.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row">
        <div class="col">
          <b-table-simple caption-top hover fixed>
            <b-thead head-variant="dark">
              <b-tr>
                <b-th>{{ $t('course-cancel-bulletin.table.header.date') }}</b-th>
                <b-th>{{ $t('course-cancel-bulletin.table.header.course') }}</b-th>
                <b-th>{{ $t('course-cancel-bulletin.table.header.lecturer') }}</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="course_cancel_record in course_cancel_records">
                <b-td>{{ course_cancel_record.cancel_date.substr(0, 10) }}</b-td>
                <b-td
                  v-if="course_cancel_record.specific"
                  colspan="2"
                >{{ course_cancel_record.cause }}</b-td>
                <b-td
                  v-if="!(course_cancel_record.specific)"
                >{{ course_cancel_record.course.title_full_name }}</b-td>
                <b-td
                  v-if="!(course_cancel_record.specific)"
                >{{ course_cancel_record.course.lecturer.lecr_full_name }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </div>      
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import Vue from 'vue'

import { stringify } from 'query-params-helpers'
import { BreadcrumbPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { TablePlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

import CourseCancelRecordApiService from '@/services/budaedu-api-services/course-cancel-record-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(IconsPlugin)
Vue.use(OverlayPlugin)
Vue.use(TablePlugin)

Vue.use(CourseCancelRecordApiService)

export default {
  i18n,
  name: 'course-cancel-bulletin',
  props: {
    // 
  },
  data() {
    return {
      is_loading: false,
      course_cancel_records: []
    }
  },
  methods: {
    getTodayDateString() {
      const today = new Date();
      const year = today.getFullYear()
      const month = today.getMonth() + 1
      const date = today.getDate()
      return `${year}-${month < 10 ? `0${month}` : month}-${date < 10 ? `0${date}` : date}`
    },
    async setCourseCancelRecords() {
      this.is_loading = true
      this.course_cancel_records = []
      try {
        const today_date = this.getTodayDateString()
        let params = stringify({
          include: 'course.lecturer',
          filter: { cancel_date: { gte: today_date } },
          order: 'cancel_date,asc'
        }).substr(1)

        const course_cancel_records = await this.$courseCancelRecordApiService.query(params)
        this.course_cancel_records = course_cancel_records.data
      } finally {
        this.is_loading = false
      }
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
    await this.setCourseCancelRecords()
  },
  components: {
    // 
  },
  metaInfo() {
    return {
      title: this.$t('course-cancel-bulletin.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>